import {
  SET_BOOKMARKS,
  ADD_BOOKMARK,
  REMOVE_BOOKMARK,
} from 'legacy/src/constants/types';

const setBookmarks = (bookmarks) => {
  return (dispatch) => {
    dispatch({ type: SET_BOOKMARKS, payload: bookmarks });
  };
};

const addBookmark = (bookmark) => {
  return (dispatch) => {
    dispatch({
      type: ADD_BOOKMARK,
      payload: bookmark,
    });
  };
};

const removeBookmark = (bookmark) => {
  return (dispatch) =>
    dispatch({
      type: REMOVE_BOOKMARK,
      payload: bookmark,
    });
};

export { setBookmarks, addBookmark, removeBookmark };
